import { render, staticRenderFns } from "./Uploading.vue?vue&type=template&id=3309f1a5&scoped=true"
import script from "./Uploading.vue?vue&type=script&setup=true&lang=js"
export * from "./Uploading.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Uploading.vue?vue&type=style&index=0&id=3309f1a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3309f1a5",
  null
  
)

export default component.exports